import { auth } from '../firebase';
import { env } from '../env';

/**
 * Authorization header for orchestrator calls.
 *
 * Prefers the signed-in user's Firebase ID token (verified per-request by the
 * orchestrator). Falls back to the shared bearer token only when no user is
 * signed in AND a token was injected at build time (dev convenience). In
 * production no bearer is baked into the bundle, so an unauthenticated call
 * fails fast with a clear message.
 */
export async function orchestratorAuthHeader(): Promise<string> {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    return `Bearer ${token}`;
  }

  const fallback = env.orchestratorBearerToken?.trim();
  if (fallback) return `Bearer ${fallback}`;

  throw new Error('You are not signed in. Sign in again, then retry.');
}

/** Merge the Authorization header onto any extra headers (async). */
export async function orchestratorAuthHeaders(extra?: HeadersInit): Promise<HeadersInit> {
  return { ...(extra ?? {}), Authorization: await orchestratorAuthHeader() };
}
